import type { LMSRecord } from './whoWeightLMS';

export const whoHeadCircumferenceLMS: { male: LMSRecord[]; female: LMSRecord[] } = {
  male: [
    { month: 0, L: 1.0000, M: 34.4618, S: 0.03690 },
    { month: 1, L: 1.0000, M: 37.2759, S: 0.03133 },
    { month: 2, L: 1.0000, M: 39.1285, S: 0.02997 },
    { month: 3, L: 1.0000, M: 40.5135, S: 0.02918 },
    { month: 4, L: 1.0000, M: 41.6317, S: 0.02868 },
    { month: 5, L: 1.0000, M: 42.5576, S: 0.02837 },
    { month: 6, L: 1.0000, M: 43.3306, S: 0.02817 },
    { month: 7, L: 1.0000, M: 43.9803, S: 0.02804 },
    { month: 8, L: 1.0000, M: 44.5300, S: 0.02796 },
    { month: 9, L: 1.0000, M: 44.9998, S: 0.02792 },
    { month: 10, L: 1.0000, M: 45.4051, S: 0.02790 },
    { month: 11, L: 1.0000, M: 45.7573, S: 0.02789 },
    { month: 12, L: 1.0000, M: 46.0661, S: 0.02789 },
    { month: 13, L: 1.0000, M: 46.3395, S: 0.02789 },
    { month: 14, L: 1.0000, M: 46.5844, S: 0.02791 },
    { month: 15, L: 1.0000, M: 46.8060, S: 0.02792 },
    { month: 16, L: 1.0000, M: 47.0088, S: 0.02795 },
    { month: 17, L: 1.0000, M: 47.1962, S: 0.02797 },
    { month: 18, L: 1.0000, M: 47.3711, S: 0.02800 },
    { month: 19, L: 1.0000, M: 47.5357, S: 0.02803 },
    { month: 20, L: 1.0000, M: 47.6919, S: 0.02806 },
    { month: 21, L: 1.0000, M: 47.8408, S: 0.02810 },
    { month: 22, L: 1.0000, M: 47.9833, S: 0.02813 },
    { month: 23, L: 1.0000, M: 48.1201, S: 0.02817 },
    { month: 24, L: 1.0000, M: 48.2515, S: 0.02821 },
    { month: 25, L: 1.0000, M: 48.3777, S: 0.02828 },
    { month: 26, L: 1.0000, M: 48.4989, S: 0.02834 },
    { month: 27, L: 1.0000, M: 48.6151, S: 0.02834 },
    { month: 28, L: 1.0000, M: 48.7264, S: 0.02837 },
    { month: 29, L: 1.0000, M: 48.8331, S: 0.02841 },
    { month: 30, L: 1.0000, M: 48.9351, S: 0.02847 },
    { month: 31, L: 1.0000, M: 49.0327, S: 0.02852 },
    { month: 32, L: 1.0000, M: 49.1260, S: 0.02857 },
    { month: 33, L: 1.0000, M: 49.2153, S: 0.02862 },
    { month: 34, L: 1.0000, M: 49.3007, S: 0.02862 },
    { month: 35, L: 1.0000, M: 49.3826, S: 0.02868 },
    { month: 36, L: 1.0000, M: 49.4612, S: 0.02871 },
  ],
  female: [
    { month: 0, L: 1.0000, M: 33.8787, S: 0.03496 },
    { month: 1, L: 1.0000, M: 36.5463, S: 0.03210 },
    { month: 2, L: 1.0000, M: 38.2521, S: 0.03168 },
    { month: 3, L: 1.0000, M: 39.5328, S: 0.03140 },
    { month: 4, L: 1.0000, M: 40.5817, S: 0.03119 },
    { month: 5, L: 1.0000, M: 41.4590, S: 0.03102 },
    { month: 6, L: 1.0000, M: 42.1995, S: 0.03087 },
    { month: 7, L: 1.0000, M: 42.8290, S: 0.03075 },
    { month: 8, L: 1.0000, M: 43.3671, S: 0.03063 },
    { month: 9, L: 1.0000, M: 43.8300, S: 0.03053 },
    { month: 10, L: 1.0000, M: 44.2319, S: 0.03044 },
    { month: 11, L: 1.0000, M: 44.5844, S: 0.03035 },
    { month: 12, L: 1.0000, M: 44.8965, S: 0.03027 },
    { month: 13, L: 1.0000, M: 45.1752, S: 0.03019 },
    { month: 14, L: 1.0000, M: 45.4265, S: 0.03012 },
    { month: 15, L: 1.0000, M: 45.6551, S: 0.03006 },
    { month: 16, L: 1.0000, M: 45.8650, S: 0.02999 },
    { month: 17, L: 1.0000, M: 46.0598, S: 0.02993 },
    { month: 18, L: 1.0000, M: 46.2424, S: 0.02987 },
    { month: 19, L: 1.0000, M: 46.4152, S: 0.02982 },
    { month: 20, L: 1.0000, M: 46.5801, S: 0.02977 },
    { month: 21, L: 1.0000, M: 46.7384, S: 0.02972 },
    { month: 22, L: 1.0000, M: 46.8913, S: 0.02967 },
    { month: 23, L: 1.0000, M: 47.0391, S: 0.02962 },
    { month: 24, L: 1.0000, M: 47.1822, S: 0.02957 },
    { month: 25, L: 1.0000, M: 47.3204, S: 0.02953 },
    { month: 26, L: 1.0000, M: 47.4536, S: 0.02949 },
    { month: 27, L: 1.0000, M: 47.5817, S: 0.02946 },
    { month: 28, L: 1.0000, M: 47.7045, S: 0.02943 },
    { month: 29, L: 1.0000, M: 47.8219, S: 0.02941 },
    { month: 30, L: 1.0000, M: 47.9340, S: 0.02933 },
    { month: 31, L: 1.0000, M: 48.0410, S: 0.02930 },
    { month: 32, L: 1.0000, M: 48.1432, S: 0.02928 },
    { month: 33, L: 1.0000, M: 48.2408, S: 0.02923 },
    { month: 34, L: 1.0000, M: 48.3343, S: 0.02919 },
    { month: 35, L: 1.0000, M: 48.4239, S: 0.02917 },
    { month: 36, L: 1.0000, M: 48.5099, S: 0.02914 },
  ],
};
